import Vue from 'vue'
import Vuex from 'vuex'
import Api from './services/menu'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: './assets/sidebar-1.jpg',
    drawer: null,
    versao: '1.0.0',
    filtrosCarregados: false,
    filtros: {
      empresa: [],
      select: [],
      vendedor: [],
      vendedorRelacao: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      classificacao: [],
      produto: [],
      cidade: [],
      categoria: [],
      promotor: [],
      linhasleite: [],
      linhasProducao: [],
      clientes: [],
      caixa: [],
      tiposDevolucao: [],
      motivosDevolucao: [],
      tiposBrinde: [],
      motivosBrinde: [],
      anosFaturamento: [],
      produtor: [],
      motorista: [],
      statusEntrega: [],
    },
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    VERSAO (state, payload) {
      state.versao = payload
    },
    SET_FILTROS (state, payload) {
      state.filtros.empresa = payload.empresas || []
      state.filtros.select = payload.empresas.length === 1 || []
      state.filtros.vendedorRelacao = payload.vendedoresRelacao || []
      state.filtros.vendedor = payload.vendedoresRelacao?.length ? payload.vendedoresRelacao : payload.vendedores || []
      state.filtros.area = payload.area || []
      state.filtros.rede = payload.rede || []
      state.filtros.supervisor = payload.supervisor || []
      state.filtros.receita = payload.receita || []
      state.filtros.segmento = payload.segmentos || []
      state.filtros.classificacao = payload.classificacao || []
      state.filtros.produto = payload.produtos || []
      state.filtros.cidade = payload.cidades || []
      state.filtros.categoria = payload.categoria || []
      state.filtros.promotor = payload.promotor || []
      state.filtros.linhasProducao = payload.linhasProducao || []
      state.filtros.clientes = payload.clientes || []
      state.filtros.caixa = payload.caixas || []
      state.filtros.tiposDevolucao = payload.tipoDevolucao || []
      state.filtros.motivosDevolucao = payload.motivoDevolucao || []
      state.filtros.tiposBrinde = payload.tipoBrinde || []
      state.filtros.motivosBrinde = payload.motivoBrinde || []
      state.filtros.anosFaturamento = payload.anosFaturamento || []
      state.filtros.linhasleite = payload.linhasleite || []
      state.filtros.produtor = payload.produtores || []
      state.filtros.motorista = payload.motorista || []
      state.filtros.statusEntrega = payload.statusEntrega || []
      state.filtrosCarregados = true
    },
  },
  actions: {
    async carregarFiltros ({ state, commit }) {
      if (state.filtrosCarregados) return

      try {
        const resposta = await Api.showEmpresas(localStorage.tokencontrato, localStorage.username)

        if (resposta.data.status) {
          commit('SET_FILTROS', resposta.data)
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
})
